import { ReactNode, Dispatch, SetStateAction } from "react";
import { CustomColoredTabs } from "../../CustomColoredTabs/CustomColoredTabs.component";

type Props = {
  children: ReactNode;
  selectedTab: number;
  setSelectedTab: Dispatch<SetStateAction<number>>;
  ["data-testid"]: string;
};

export function ReportTabs({
  children,
  selectedTab,
  setSelectedTab,
  ["data-testid"]: dataTestId
}: Readonly<Props>) {
  return (
    <CustomColoredTabs
      data-testid={dataTestId}
      value={selectedTab}
      onChange={(event, newValue: number) => setSelectedTab(newValue)}
      sx={{ mb: 4 }}
    >
      {children}
    </CustomColoredTabs>
  );
}
